import { roleGuard } from '@zvoove-market/shared';
import {
  ADMIN_ROLE,
  BUSINESS_EXECUTIVE_ROLE,
  CUSTOMER_BASE_ACCESS_ROLE_GROUP,
  PARTNER_ROLE,
  PAYROLL_MANAGER_ROLE,
  ZVOOVE_CONTENT_MANAGER_ROLE,
  ZVOOVE_CUSTOMER_SUCCESS_ROLE,
  ZVOOVE_EMPLOYEE_ROLE,
  ZVOOVE_SUPER_ADMIN_ROLE,
  ZVOOVE_SYSTEM_OPERATOR_ROLE,
} from '../auth/roles';

export const mandantAdminRoleGuard = () =>
  roleGuard({
    mandantRoles: [ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE],
    condition: 'any',
  });

export const customerAdminRoleGuard = () =>
  roleGuard({
    customerRoles: [ADMIN_ROLE, BUSINESS_EXECUTIVE_ROLE],
    condition: 'any',
  });

export const customerRoleGuard = () =>
  roleGuard({
    mandantRoles: CUSTOMER_BASE_ACCESS_ROLE_GROUP,
    condition: 'any',
  });

export const payrollManagerRoleGuard = () =>
  roleGuard({
    globalRoles: [PAYROLL_MANAGER_ROLE],
    condition: 'any',
  });

export const canAccessCustomerSupportGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_CUSTOMER_SUCCESS_ROLE, ZVOOVE_SUPER_ADMIN_ROLE],
    condition: 'any',
  });

export const canSeeContentManagementGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_SYSTEM_OPERATOR_ROLE, ZVOOVE_CONTENT_MANAGER_ROLE],
    condition: 'any',
  });

export const zvooveContentManagerRoleGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_CONTENT_MANAGER_ROLE],
    condition: 'any',
  });

export const zvooveCustomerSuccessRoleGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_CUSTOMER_SUCCESS_ROLE],
    condition: 'any',
  });

export const partnerRoleGuard = () =>
  roleGuard({
    globalRoles: [PARTNER_ROLE],
    condition: 'any',
  });

export const zvooveEmployeeRoleGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_EMPLOYEE_ROLE],
    condition: 'any',
  });

export const zvooveSuperAdminRoleGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_SUPER_ADMIN_ROLE],
    condition: 'any',
  });

export const zvooveSystemOperatorRoleGuard = () =>
  roleGuard({
    globalRoles: [ZVOOVE_SYSTEM_OPERATOR_ROLE],
    condition: 'any',
  });
